module.exports = {
    title: "Withdrawal Request",
    details: "Withdrawal Request Details",
    description: "Description",
    referenceLink: "Reference Link",
    blockReason: "Block Reason",
    rejectionReason: "Rejection Reason",
    user: {
        name: 'Name'
    },
    validation: {
        required: {
            title: 'Title is required',
        }
    },
}
